import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Row, Col, Label, Form, Alert, Input, FormFeedback } from 'reactstrap';
import neoLogo from "../../assets/images/Neo_Logo_A.svg";
import neoLogoC from "../../assets/images/Neo_Logo_C.svg";
import new1Bg from "../../assets/images/new1Bg.png";
import LoadingButton from "../../components/Common/LoadingButton";
import { useAuth } from "../../hooks/useAuth";

// Formik validation
import * as Yup from "yup";
import { useFormik } from "formik";

const Login = () => {
  document.title = "Login | NeoApp - Sistema de Gestão";
  const navigate = useNavigate();
  const { login } = useAuth();
  
  const [errorMSG, setErrorMSG] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);

  const validation = useFormik({
    enableReinitialize: true,
    initialValues: {
      email: "",
      password: "",
    },
    validationSchema: Yup.object({
      email: Yup.string().email("E-mail inválido").required("Por favor, insira seu e-mail"),
      password: Yup.string().required("Por favor, insira sua senha"),
    }),
    onSubmit: async (values) => {
      setIsSubmitting(true);
      setErrorMSG("");
      try {
        await login(values.email, values.password);
        navigate('/dashboard'); // Ajuste a rota para onde o usuário deve ir após o login
      } catch (err) {
        if (err.code === 'auth/wrong-password' || err.code === 'auth/user-not-found' || err.code === 'auth/invalid-credential') {
          setErrorMSG("Usuário ou senha inválidos.");
        } else if (err.message) {
          setErrorMSG(err.message);
        } else {
          setErrorMSG("Ocorreu um erro ao fazer login.");
        }
      } finally {
        setIsSubmitting(false);
      }
    }
  });

  return (
    <React.Fragment>
      <div className="account-pages" style={{
        backgroundImage: `url(${new1Bg})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
        height: '100vh',
        width: '100%',
        position: 'fixed',
        top: 0,
        left: 0
      }}>
        <div className="container-fluid p-0">
          <Row className="g-0 vh-100">
            {/* Left side: Transparent spacer */}
            <Col lg={8} xl={9} className="d-none d-lg-block position-relative">
              <img
                src={neoLogoC}
                alt="NeoApp Logo"
                style={{
                  position: 'absolute',
                  bottom: '40px',
                  left: '60px',
                  height: '95px',
                  filter: 'brightness(0) invert(1)',
                  opacity: 0.9
                }}
              />
            </Col>

            {/* Right side: Translucent Login Form */}
            <Col lg={4} xl={3} className="d-flex align-items-center" style={{
              backgroundColor: 'rgba(255, 255, 255, 0.8)',
              backdropFilter: 'blur(15px)',
              boxShadow: '-10px 0 30px rgba(0,0,0,0.1)',
              borderLeft: '1px solid rgba(255,255,255,0.2)'
            }}>
              <div className="p-4 p-sm-5 w-100">
                <div className="mb-5 text-center">
                  <Link to="/" className="d-block auth-logo">
                    <img src={neoLogo} alt="NeoApp" height="38" className="auth-logo-dark mx-auto" />
                  </Link>
                </div>

                <div className="mb-4">
                  <h4 className="text-primary fw-bold">Bem-vindo de volta!</h4>
                  <p className="text-muted">Acesse sua conta para continuar.</p>
                </div>

                <Form
                  className="form-horizontal"
                  onSubmit={(e) => {
                    e.preventDefault();
                    validation.handleSubmit();
                    return false;
                  }}
                >
                  {errorMSG ? (
                    <Alert color="danger" isOpen={!!errorMSG} fade={false}>
                      {errorMSG}
                    </Alert>
                  ) : null}

                  <div className="mb-3">
                    <Label htmlFor="email" className="form-label">E-mail</Label>
                    <Input
                      name="email"
                      className="form-control form-control-lg"
                      placeholder="Digite seu e-mail"
                      type="email"
                      onChange={validation.handleChange}
                      onBlur={validation.handleBlur}
                      value={validation.values.email || ""}
                      invalid={
                        validation.touched.email && validation.errors.email ? true : false
                      }
                    />
                    {validation.touched.email && validation.errors.email ? (
                       <FormFeedback type="invalid">{validation.errors.email}</FormFeedback>
                    ) : null}
                  </div>

                  <div className="mb-3">
                    <Label htmlFor="userpassword" className="form-label">Senha</Label>
                    <Input
                      name="password"
                      value={validation.values.password || ""}
                      type="password"
                      className="form-control form-control-lg"
                      placeholder="Digite sua senha"
                      onChange={validation.handleChange}
                      onBlur={validation.handleBlur}
                      invalid={
                        validation.touched.password && validation.errors.password ? true : false
                      }
                    />
                    {validation.touched.password && validation.errors.password ? (
                      <FormFeedback type="invalid">{validation.errors.password}</FormFeedback>
                    ) : null}
                  </div>

                  <div className="mt-4 d-grid">
                    <LoadingButton 
                      color="primary" 
                      className="btn-lg waves-effect waves-light" 
                      type="submit"
                      loading={isSubmitting}
                      disabled={isSubmitting}
                    >
                      Entrar
                    </LoadingButton>
                  </div>
                </Form>

                <div className="mt-5 text-center text-muted">
                  <p className="mb-0">© {new Date().getFullYear()} NeoApp</p>
                </div>
              </div>
            </Col>
          </Row>
        </div>
      </div>
    </React.Fragment>
  )
}

export default Login;
